import { FC } from 'react'
import { useTheme } from '@mui/material/styles'
import { alpha } from '@mui/material/styles'

import type { WeGotTheBeat } from '../interfaces'
import BeatMaterialIcon from './BeatMaterialIcon'
import { getComparisonColorType } from '../utils/colorType'

export const AverageSpendComparisonIcon: FC<WeGotTheBeat> = ({ beat }) => {
  const theme = useTheme()

  // Get average spend from payload
  const averageSpend = beat.payload?.average_spend || 0

  // Get recent month value from data_series
  let recentMonthValue = 0
  if (beat.data_series?.data && beat.data_series.data.length > 0) {
    const names = beat.data_series.names || []
    const amountIndex = names.indexOf('amount')
    if (amountIndex !== -1) {
      recentMonthValue = beat.data_series.data[0][amountIndex] || 0
    }
  }

  // Determine color based on comparison
  const colorType = getComparisonColorType(recentMonthValue, averageSpend)

  return (
    <BeatMaterialIcon
      bgColor={alpha(theme.palette[colorType].main, 0.15)}
      iconColor={colorType}
      name="timeline"
    />
  )
}
